module.exports = __webpack_public_path__ + "static/media/ic-twitter.888f9168.svg";